<template>
  <Tooltip
    placement="top"
    :options="TOOLTIP_OPTIONS"
    :disabled="names.length < 2"
  >
    <template #trigger>
      <span
        class="inline-flex items-center gap-1"
        :class="{ 'cursor-help': names.length > 1 }"
        :tabindex="names.length > 1 ? 0 : undefined"
        data-cy="job-cost-service-categories"
      >
        <span>{{ names[0] }}</span>
        <Badge
          v-if="names.length > 1"
          variant="chip"
          color="gray"
          data-cy="job-cost-service-categories-more"
          :text="`+${names.length - 1}`"
        />
      </span>
    </template>
    <template #tooltip>
      <ul class="text-left text-xs" data-cy="job-cost-service-categories-list">
        <li v-for="name in names" :key="name">{{ name }}</li>
      </ul>
    </template>
  </Tooltip>
</template>

<script setup lang="ts">
import Badge from "@/components/Badge.vue";
import Tooltip from "@/components/Tooltip.vue";

// Every category on the job's appointments, the primary appointment's first.
defineProps<{ names: string[] }>();

// hideOnClick: a tap outside closes it on a phone; Tooltip.vue defaults it off.
const TOOLTIP_OPTIONS = { hideOnClick: true };
</script>
